import { render, staticRenderFns } from "./ReferencedField.vue?vue&type=template&id=6dcb33a9&scoped=true&"
import script from "./ReferencedField.vue?vue&type=script&lang=js&"
export * from "./ReferencedField.vue?vue&type=script&lang=js&"
import style0 from "./ReferencedField.vue?vue&type=style&index=0&id=6dcb33a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb33a9",
  null
  
)

export default component.exports